import { format, parse } from 'date-fns';

const UTC_STRING = ' ';

export const getUtcDateStr = (dateStr) => {
  if (dateStr.indexOf(UTC_STRING) > -1) {
    return dateStr;
  }
  return dateStr + UTC_STRING;
};

export const isUtcDate = (dateStr) => {
  return dateStr.endsWith(UTC_STRING);
};

export const generateUniqueId = () => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 10);
  const secondRandomPart = Math.random().toString(36).substring(2, 10);
  return `${timestamp}${randomPart}${secondRandomPart}`.substring(0, 12);
};

export const filterUniqueOptions = (options) => {
  const filteredOptions = options.filter((option) => option !== null && option !== undefined);
  const uniqueOptions = new Set(filteredOptions);
  return [...uniqueOptions];
};

export const generateFilterOptions = (columns, data, isRecommendationTable = false) => {
  const filteredColumns = columns.reduce((acc, col) => {
    acc[col.id] = [...new Set(data.map((row) => row[col.id]))]; // Get unique values
    return acc;
  }, {});

  const regionalAlgoColumns = columns
    ?.map((list) => list.id)
    ?.map((item) => {
      if (item?.includes('agree steering team reco')) return item;
    })
    ?.filter((li) => li !== undefined);

  if (isRecommendationTable) {
    filteredColumns.taggedUsers = filteredColumns.taggedUsers?.flatMap((innerArray) =>
      innerArray?.map((item) => item.UserName)
    );
    filteredColumns.agreeDisagreeStatus = filteredColumns.agreeDisagreeStatus?.map((list) => {
      if (list) {
        return 'agree';
      } else {
        return 'disagree';
      }
    });
    filteredColumns['completionStatus'] = filteredColumns?.['completionStatus']?.map((list) => {
      if (typeof list === 'boolean' && list) {
        return 'agree';
      } else if (typeof list === 'boolean' && !list) {
        return 'disagree';
      }
    });
    filteredColumns['steering team agreement'] = filteredColumns?.['steering team agreement']?.map(
      (list) => {
        if (typeof list === 'boolean' && list) {
          return 'agree';
        } else if (typeof list === 'boolean' && !list) {
          return 'disagree';
        }
      }
    );
    filteredColumns['votes aligned'] = filteredColumns?.['votes aligned']?.map((list) => {
      if (typeof list === 'boolean' && list) {
        return 'Yes';
      } else if (typeof list === 'boolean' && !list) {
        return 'No';
      }
    });
    regionalAlgoColumns?.map((item) => {
      filteredColumns[item] = filteredColumns?.[item]?.map((list) => {
        if (typeof list === 'boolean' && list) {
          return 'agree';
        } else if (typeof list === 'boolean' && !list) {
          return 'disagree';
        }
      });
    });
    filteredColumns['functional team votes'] = null;
  }
  return filteredColumns;
};

export const isArrayBlank = (arr) => Array.isArray(arr) && arr.length === 0;

export const formatDateRange = (timeDuration) => {
  const parseDate = (dateStr) => {
    const pFormat = 'dd/MM/yyyy';
    return parse(dateStr, pFormat, new Date());
  };

  const startDate = parseDate(timeDuration.start + UTC_STRING);
  const endDate = parseDate(timeDuration.end + UTC_STRING);

  return `${format(startDate, 'MMMM d, yyyy')} - ${format(endDate, 'MMMM d, yyyy')}`;
};

export const parseIsoDate = (dateObj) => {
  const formattedDate = format(dateObj, 'dd/MM/yyyy');
  return formattedDate;
};

export function getMonthName(dateString) {
  const date = new Date(dateString);
  const options = { month: 'short' };
  return date.toLocaleString('default', options);
}

export function getMonthRange(startDate, endDate) {
  const startMonth = new Date(getUtcDateStr(startDate)).getMonth();
  const endMonth = new Date(getUtcDateStr(endDate)).getMonth();
  const startYear = new Date(getUtcDateStr(startDate)).getFullYear();
  const endYear = new Date(getUtcDateStr(endDate)).getFullYear();

  const months = [];
  for (let year = startYear; year <= endYear; year++) {
    const monthStart = year === startYear ? startMonth : 0;
    const monthEnd = year === endYear ? endMonth : 11;
    for (let month = monthStart; month <= monthEnd; month++) {
      months.push(getMonthName(new Date(year, month)));
    }
  }

  // Remove duplicates and join months with a hyphen
  const uniqueMonths = [...new Set(months)];
  return uniqueMonths.join('-');
}

export function convertComprehensiveData(originalData) {
  return originalData.map((item) => ({
    ...item,
    month: getMonthRange(item?.timeDuration?.start, item?.timeDuration?.end)
  }));
}

export const calculateWeeksbyDate = (start, end) => {
  // calculate no of weeks using start and end date
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffTime = Math.abs(endDate - startDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.ceil(diffDays / 7);
  return diffWeeks;
};

export const isDueDatePassed = ({ start, end, taskStatus }) => {
  //duedate in string dd/mm/yyyy
  const today = new Date();
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (taskStatus === 'Not Started') {
    return today > startDate;
  }
  return endDate < today;
};
export const isDueDateNear = (end, taskStatus) => {
  //duedate in string dd/mm/yyyy
  const today = new Date();
  const endDate = new Date(end);
  const threeDaysFromNow = new Date();
  threeDaysFromNow.setDate(today.getDate() + 3);
  if (['Not Started', 'In Progress'].includes(taskStatus)) {
    return endDate >= today && endDate <= threeDaysFromNow;
  }
  return false;
};
export const parseDateByDash = (dateStr) => {
  const [day, month, year] = dateStr.split('/');
  return new Date(`${year}-${month}-${day}${UTC_STRING}`); // Rearranging to YYYY-MM-DD format
};

export const statusColorCodeEnum = {
  'In Progress': '#FFECBB',
  Completed: '#B3DACB',
  'Not Started': '#D0D0D0',
  OverDue: '#F2B3BC',
  OverCompletion: '#FFDCBB',
  DueNear: '#FF891C'
};
export const stepperStatusColorCodeEnum = {
  'In Progress': '#005CBC',
  Completed: '#008553',
  'Not Started': '#3A3A3A',
  OverCompletion: '#008553',
  OverDue: '#D40020',
  DueNear: '#FF891C'
};

export const findStatusColor = (status, taskData, isStepper = false) => {
  const colorCodeEnum = isStepper ? stepperStatusColorCodeEnum : statusColorCodeEnum;
  const { start, end } = taskData?.timeDuration || {};
  const hasDatePassed = isDueDatePassed({
    start: parseDateByDash(start),
    end: parseDateByDash(end),
    taskStatus: taskData?.status
  });

  if (hasDatePassed) {
    if (['In Progress', 'Not Started'].includes(status)) {
      return colorCodeEnum['OverDue'];
    }
    if (status === 'Completed') {
      return colorCodeEnum['OverCompletion'];
    }
  } else if (isStepper && isDueDateNear(parseDateByDash(end), taskData?.status)) {
    return colorCodeEnum['DueNear'];
  }

  return colorCodeEnum[status];
};

const getCompletedTasks = (data) => {
  let subTaskCompletedCount = 0;
  // Iterate over the subtasks to check completion status
  data?.forEach((subTask) => {
    // Check if all assignees have 'Completed' status
    const allCompleted = subTask?.assignedTo?.every((assignee) => assignee?.status === 'Completed');

    if (allCompleted) {
      subTaskCompletedCount++;
    }
  });
  return subTaskCompletedCount;
};

export const convertTaskListToStepperTask = (data) => {
  if (!data) {
    return;
  }
  return data?.map((item) => ({
    timeDuration: item?.timeDuration,
    taskName: item?.name,
    status: item?.status,
    completedTask: getCompletedTasks(item?.subTasks),
    totalTask: item?.subTasks?.length,
    dueDate: item?.timeDuration?.end
  }));
};

export function isInvalidValue(value) {
  return value === undefined || value === null || value === '' || value === 'undefined';
}

export const hasCommonElement = (sourceArr, targetArr) =>
  targetArr.some((element) => sourceArr.includes(element));

/**
 * The function `convertDateFormat` takes a date string in dd/mm/yyyy format and converts it to
 * mm/dd/yyyy format.
 * @param dateString - The `dateString` parameter is a string representing a date in the format
 * "dd/mm/yyyy".
 * @returns The `convertDateFormat` function takes a date string in the format "dd/mm/yyyy", splits it
 * by '/', rearranges the parts to "mm/dd/yyyy" format, and returns the converted date string.
 */
export function convertDateFormat(dateString) {
  if (!dateString) {
    return;
  }
  // Split the date string by '/'
  const parts = dateString.split('/');

  // Rearrange the parts to mm/dd/yyyy format
  const convertedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;

  return convertedDate;
}

// Format numbers as dollar labels
export const convertToDollarLabel = (num) => {
  num = Number(num); // Ensure num is a number
  if (isNaN(num)) return '$ 0'; // Handle cases where num is NaN

  if (num >= 1_000_000_000 || num <= -1_000_000_000) {
    return `$ ${(num / 1_000_000_000).toFixed(0)} B`;
  } else if (num >= 1_000_000 || num <= -1_000) {
    return `$ ${(num / 1_000_000).toFixed(0)} M`;
  } else if (num >= 1_000 || num <= -1_000) {
    return `$ ${(num / 1_000).toFixed(0)} K`;
  } else {
    return `$ ${num.toFixed(0)}`;
  }
};

// Format date to DD-MM-YYYY
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`; // Returns date in DD-MM-YYYY format
};

export const getOptionsInStructuredFormat = (data) => {
  let newObj = {};
  Object.keys(data)?.map((key) => {
    data[key]?.map((item) => {
      if (item !== '' && item !== null) {
        newObj[key] = [...(newObj[key] ?? []), ...[{ id: item, displayText: item }]];
      }
      return item;
    });
    return key;
  });
  return newObj;
};

export const removeNullValuesFromObj = (obj) => {
  return Object.fromEntries(
    Object.entries(obj)?.filter(
      ([key, value]) =>
        value !== null && value !== undefined && (Array.isArray(value) ? value.length > 0 : true)
    )
  );
};

// Format date to MM-DD-YYYY
export const monthDateFormat = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${month}/${day}/${year}`; // Returns date in MM-DD-YYYY format
};

export const convertStringToCamelCase = (str) => {
  return str
    ?.split(' ') // Split string by spaces
    ?.map((word, index) => {
      if (index === 0) {
        return word?.toLowerCase(); // First word in lowercase
      }
      return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase(); // Capitalize subsequent words
    })
    ?.join(''); // Join the array back into a string
};

// Function to generate the year and month range
export const generateYearMonthData = () => {
  // getting yearPeriod range
  const startYear = new Date().getFullYear();
  const endYear = startYear - 2;
  const yearMonthData = [];
  for (let year = startYear; year >= endYear; year--) {
    for (let month = 1; month <= 13; month++) {
      const monthStr = month < 10 ? `0${month}` : month; // Add leading zero for single digits
      yearMonthData.push(`${year}${monthStr}`);
    }
  }
  // Sorting the yearMonthData in descending order (latest to oldest)
  let sortedData = yearMonthData?.sort((a, b) => parseInt(b, 10) - parseInt(a, 10));
  return sortedData;
};

export const convertToCurrencyWithSign = (number) => {
  if (isNaN(number)) {
    return number;
  }
  return number?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
};
export const convertToCurrency = (num) => {
  if (isNaN(num)) return '$0'; // Handle NaN case
  num = Number(num);
  // Handle values that round to 0 (including negatives like -0.01)
  if (Math.round(num) === 0) {
    return '$0';
  }
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });
};

export const convertToAbbreviatedNumber = (num) => {
  num = Number(num); // Ensure num is a number
  if (isNaN(num)) return '0'; // Handle NaN case

  const absNum = Math.abs(num);
  let suffix = '';
  let value = num;

  if (absNum >= 1_000_000_000_000) {
    value = num / 1_000_000_000_000;
    suffix = 'T';
  } else if (absNum >= 1_000_000_000) {
    value = num / 1_000_000_000;
    suffix = 'B';
  } else if (absNum >= 1_000_000) {
    value = num / 1_000_000;
    suffix = 'M';
  }

  return `${Math.round(value)}${suffix}`;
};

export const convertToCurrencyAbbreviated = (num) => {
  if (Math.abs(num) < 1_000_000) {
    return convertToCurrency(num); // Return normal currency format if below 1M
  }
  return convertToCurrency(Math.round(num)) + convertToAbbreviatedNumber(num).replace(/^-?\d+/, '');
};

export const convertToCurrencyWithoutSign = (number) => {
  if (isNaN(number)) {
    return number;
  }
  return number?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const convertToCurrencyWithPercent = (number) => {
  if (number === null || isNaN(number)) {
    return '0%';
  }
  return Math.round(number).toLocaleString('en-US') + '%';
};

export const convertToRoundOffWithNumberOfDecimals = (number, decimalPlaces = 0) => {
  if (isNaN(number)) {
    return number;
  }
  if (number === null || number === undefined) {
    return number;
  }
  const roundedNumber = Number(number).toFixed(decimalPlaces);
  const parts = roundedNumber.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add comma separation
  return parts.join('.');
};

export const convertToRoundOffWithNumberOfDecimalsWithPercent = (number, decimalPlaces = 0) => {
  if (number === null || number === undefined || isNaN(number)) {
    return '0%';
  }

  const roundedNumber = Number(number).toFixed(decimalPlaces);
  const parts = roundedNumber.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add comma separation

  return parts.join('.') + '%';
};

export const convertToPercentageWithDecimal = (num, decimalPlaces = 0) => {
  return `${Number(num).toFixed(decimalPlaces)}%`; // Format with specified decimal places and append %
};

export const getUrlWithParams = (path, bu, cycleName = null, cycleId = null) => {
  return cycleName && cycleId
    ? `${path}?bu=${encodeURIComponent(bu)}&cycleName=${encodeURIComponent(cycleName)}&cycleId=${encodeURIComponent(cycleId)}`
    : `${path}?bu=${encodeURIComponent(bu)}`;
};

export const sanitizeFileName = (name) => {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_');
};
